import { render, staticRenderFns } from "./ReviewField.vue?vue&type=template&id=532e57c1&scoped=true&"
import script from "./ReviewField.vue?vue&type=script&lang=js&"
export * from "./ReviewField.vue?vue&type=script&lang=js&"
import style0 from "./ReviewField.vue?vue&type=style&index=0&id=532e57c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e57c1",
  null
  
)

export default component.exports